import React from "react";
import { SvgProps } from "../../types";

export const EventOutdateIcon = (props: SvgProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width}
      height={props.height}
      viewBox="0 0 32 32"
      className={props.classNames?.join(" ") || ""}
    >
      <rect width="32" height="32.0004" rx="16" fill="#FF6E13"/>
      <path fillRule="evenodd" 
      clipRule="evenodd" 
      d="M6 16C6 10.477 10.477 6 16 6C21.523 6 26 10.477 26 16C26 21.523 21.523 26 16 26C10.477 26 6 21.523 6 16ZM17 12C17 11.7348 16.8946 11.4804 16.7071 11.2929C16.5196 11.1054 16.2652 11 16 11C15.7348 11 15.4804 11.1054 15.2929 11.2929C15.1054 11.4804 15 11.7348 15 12V16C15.0001 16.2652 15.1055 16.5195 15.293 16.707L18.293 19.707C18.4816 19.8892 18.7342 19.99 18.9964 19.9877C19.2586 19.9854 19.5094 19.8802 19.6948 19.6948C19.8802 19.5094 19.9854 19.2586 19.9877 18.9964C19.99 18.7342 19.8892 18.4816 19.707 18.293L17 15.586V12Z" fill="white"/>
    </svg>
  );
};